<div class="ziti-page-container lt-skin-page">
  <lib-list-table-header
    title="OIDC Audiences"
    subtitle="The audiences that an OIDC issuer accepts tokens for"
    createLabel="Create OIDC Audience"
    infoText="An OIDC audience is a value an issuer's tokens must carry to be accepted by this organization."
    [tabs]="tabs"
    [showAdd]="!hasSelection"
    [blockCreate]="!canCreate"
    [blockDelete]="createVisibility.isCancelledAccount"
    (actionClicked)="onHeaderAction($event)"
  >
    <span header-icon class="icon-CAs" aria-hidden="true"></span>
  </lib-list-table-header>

  <div class="oidc-audiences-panel-row" [class.is-split]="!!selected">
    <div class="oidc-audiences-list-panel">
      <lib-list-table
        class="lt-skin"
        [tableId]="tableId"
        [initialPageSize]="initialPageSize"
        [options]="tableOptions"
        [columns]="listColumns"
        [rowData]="rows"
        [isLoading]="isLoading"
        [hasNext]="list.hasNext"
        [hasPrev]="list.hasPrev"
        [startCount]="list.startCount"
        [endCount]="list.endCount"
        [totalCount]="list.totalCount"
        [filterApplied]="list.filterApplied"
        [filterColumn]="searchFilter"
        [menuItems]="menuItems"
        [headerActions]="headerActions"
        [accessDenied]="accessDenied"
        filterName="Audience"
        entityTypeName="OIDC audiences"
        noItemsImage="nodata"
        [showNoItemsAdd]="canCreate"
        [noItemsReadonly]="!canCreate"
        (actionRequested)="onAction($event)"
      ></lib-list-table>
    </div>

    @if (selected; as audience) {
      <app-detail-drawer
        eyebrow="OIDC Audience Detail"
        [title]="audience.audience"
        [index]="selectedIndex"
        [total]="list.rows.length"
        (closed)="closeDetail()"
        (navigated)="navigateDetail($event)"
      >
        <app-record-detail
          [sections]="detailSections(audience)"
          [actions]="detailActions(audience)"
          (action)="onAction({ action: $event, item: audience })"
        ></app-record-detail>
      </app-detail-drawer>
    }
  </div>
</div>
